import { NavLink } from "react-router-dom";
import { Home, Radio, MessageCircle, Users, User, Plus } from "lucide-react";

const navItems = [
  { to: "/feed", label: "Feed", icon: Home, testid: "nav-feed" },
  { to: "/live", label: "Live", icon: Radio, testid: "nav-live" },
  { to: "/create", label: "Create", icon: Plus, testid: "nav-create", special: true },
  { to: "/chats", label: "Chats", icon: MessageCircle, testid: "nav-chats" },
  { to: "/crews", label: "Crews", icon: Users, testid: "nav-crews" },
  { to: "/profile", label: "Me", icon: User, testid: "nav-profile" },
];

const BottomNav = () => {
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-md border-t-2 border-[#0A0A0A]"
      data-testid="bottom-nav"
    >
      <div className="max-w-2xl mx-auto px-2 h-16 flex items-stretch justify-between">
        {navItems.map((item) => {
          const Icon = item.icon;
          if (item.special) {
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className="flex flex-col items-center justify-center -mt-6"
                data-testid={item.testid}
              >
                <div className="w-14 h-14 bg-[#FF6A2C] brutal-border rounded-full brutal-shadow flex items-center justify-center">
                  <Icon className="w-6 h-6 text-white" strokeWidth={2.5} />
                </div>
              </NavLink>
            );
          }
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex-1 flex flex-col items-center justify-center gap-0.5 ${
                  isActive ? "text-[#FF6A2C]" : "text-[#555555]"
                }`
              }
              data-testid={item.testid}
            >
              {({ isActive }) => (
                <>
                  <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 2} />
                  <span className="label-mono">{item.label}</span>
                  {isActive && <span className="w-1 h-1 bg-[#FF6A2C] rounded-full -mt-0.5" />}
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
